import { render, staticRenderFns } from "./Compliance_Dashboard.vue?vue&type=template&id=1be97c11"
import script from "./Compliance_Dashboard.vue?vue&type=script&lang=js"
export * from "./Compliance_Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Compliance_Dashboard.vue?vue&type=style&index=0&id=1be97c11&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports